// export const protocol = "http";
// export const socket = "ws";
// export const server = "localhost:8080/aeither";

export const protocol = "https";
export const socket = "wss";

export const server = "aetheracemaster.onrender.com/aeither";
// export const server = "ace-master.onrender.com/aeither";